import React from "react";

/**
 * Infinite horizontal marquee. Items are duplicated to ensure seamless loop.
 * tone: 'light' (dodgers bg) | 'dark' (galactico bg)
 */
const Marquee = ({ items = [], tone = "light", className = "" }) => {
  const color = tone === "light" ? "text-galactico" : "text-dodgers";
  return (
    <div
      className={`overflow-hidden marquee-paused border-y border-current/15 py-6 md:py-8 ${color} ${className}`}
      data-testid="marquee"
      role="marquee"
    >
      <div className="marquee-track gap-12 md:gap-16 whitespace-nowrap">
        {[...items, ...items].map((w, i) => (
          <span
            key={i}
            className="font-display text-2xl md:text-4xl tracking-tight flex items-center gap-12 md:gap-16"
          >
            {w}
            <span
              className="inline-block w-3 h-3 rounded-full bg-lime"
              aria-hidden="true"
            />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
